export const CONVERSATION_ARCHITECTURE_BEATS = [
  {
    title: 'Open with the unexpected',
    detail: "Start with something about who they are that isn't on their resume",
  },
  {
    title: 'Go somewhere personal in the middle',
    detail: 'Every episode needs a human moment, find it',
  },
  {
    title: 'Connect to the ideology',
    detail: 'At least once, let the conversation touch the burden of leadership',
  },
  {
    title: 'Close forward-facing',
    detail: "End with where they're headed, not where they've been",
  },
];
